<quill-editor
  #ngxQuillInstance
  [ngModel]="text"
  (ngModelChange)="onTextChange($event)"
  (onEditorCreated)="onEditorCreated($event, ngxQuillInstance)"
  [readOnly]="readonly"
  [format]="format"
  bounds="self"
  [modules]="editorModules"
  [placeholder]="placeholder"
  [class.modal-padding]="modalPadding"
  [theme]="!withToolbar ? 'bubble' : ''"
  [class.readonly]="readonly"
  [class.no-toolbar]="!withToolbar"
>
  <div
    quill-editor-toolbar
    [dtWidthTrigger]="{ 'medium-breakpoint': 930, 'small-breakpoint': 646, 'mobile-breakpoint': 450 }"
    (dtWidthTriggerStateChange)="
      isMediumBreakpoint = $event['medium-breakpoint'];
      isSmallBreakpoint = $event['small-breakpoint'];
      isMobileBreakpoint = $event['mobile-breakpoint']
    "
  >
    <div class="tools">
      <div [ngClass]="{ mobile: isMobileBreakpoint }">
        @if (withToolbar) {
          <span class="ql-formats">
            <select class="ql-header" i18n-title title="Stil">
              <option value="1">Heading 1</option>
              <option value="2">Heading 2</option>
              <option value="false" selected>Normal</option>
              <option value="5">Footnotes</option>
            </select>
          </span>
          <span class="ql-formats">
            <button class="ql-bold" i18n-title title="Fett"></button>
            <button class="ql-italic" i18n-title title="Kursiv"></button>
            <button class="ql-underline" i18n-title title="Unterstrichen"></button>
            <button class="ql-strike" i18n-title title="Durchgestrichen"></button>
          </span>

          <span class="ql-formats">
            <select class="ql-color" i18n-title title="Schriftfarbe"></select>
            <select class="ql-background" i18n-title title="Hervorhebungsfarbe"></select>
          </span>
          <span class="ql-formats">
            <select class="ql-font" i18n-title title="Schriftart">
              <option selected></option>
              <option value="serif"></option>
              <option value="monospace"></option>
            </select>
          </span>
        } @else {
          <span class="ql-formats">
            <button class="ql-bold" i18n-title title="Fett"></button>
            <button class="ql-italic" i18n-title title="Kursiv"></button>
            <button class="ql-underline" i18n-title title="Unterstrichen"></button>
            <button class="ql-strike" i18n-title title="Durchgestrichen"></button>
          </span>
        }
      </div>

      <div [ngClass]="{ show: showExtraTools, stacked: isSmallBreakpoint }">
        <span class="ql-formats">
          <select class="ql-align" i18n-title title="Textausrichtung">
            <option selected></option>
            <option value="center"></option>
            <option value="right"></option>
            <option value="justify"></option>
          </select>
        </span>
        <span class="ql-formats">
          <button class="ql-script" value="sub" i18n-title title="Tiefgestellt"></button>
          <button class="ql-script" value="super" i18n-title title="Hochgestellt"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-indent" value="-1" i18n-title title="Einzug verringern"></button>
          <button class="ql-indent" value="+1" i18n-title title="Einzug vergrößern"></button>
        </span>
      </div>
      <div [ngClass]="{ show: showExtraTools, stacked: isMediumBreakpoint }">
        <span class="ql-formats">
          <button class="ql-list" value="ordered" i18n-title title="Nummerierung"></button>
          <button class="ql-list" value="bullet" i18n-title title="Aufzählung"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-blockquote" i18n-title title="Blockzitat"></button>
          <button class="ql-code-block" i18n-title title="Code Block"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-direction" value="rtl" i18n-title title="Schreibrichtung"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-clean" i18n-title title="Formatierung entfernen"></button>
        </span>
        <span class="ql-formats">
          <button class="ql-link" i18n-title title="Link einfügen"></button>
          <button #imageUploadButton class="ql-image-upload" i18n-title title="Bild einfügen (hochladen)" (click)="imageInput.click()">
            <mat-icon class="small-icon">add_photo_alternate</mat-icon></button
          >
          <input #imageInput type="file" accept="image/*" style="display: none" (change)="uploadImage(imageInput, imageUploadButton)" />
        </span>
      </div>
    </div>
    @if (withToolbar) {
      <button
        class="expand-button"
        (click)="toggleExtraTools()"
        [title]="showExtraTools ? 'Weniger Optionen anzeigen' : 'Weitere Optionen anzeigen'"
        [ngClass]="{ show: isMediumBreakpoint }"
        i18n-title
      >
        <mat-icon>{{ showExtraTools ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
    }
  </div>
</quill-editor>
